module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-center-b72e6a0779326fe6b90780ce252a98d6.svg";